import { render, staticRenderFns } from "./comp_AppBar-ButtonCart.vue?vue&type=template&id=8ecd8f0e&"
import script from "./comp_AppBar-ButtonCart.vue?vue&type=script&lang=js&"
export * from "./comp_AppBar-ButtonCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
